import cn from 'classnames'
import ReactPlayer from 'react-player/youtube'
import styles from './Video.module.css'

interface VideoProps extends React.ComponentPropsWithoutRef<'div'> {
  link: string
  playing?: boolean
  onPauseOrEnded: () => void
  className?: string
}

export function extractYoutubeVideoId(link: string): string | undefined {
  // eslint-disable-next-line regexp/no-unused-capturing-group,regexp/no-super-linear-backtracking,regexp/no-empty-capturing-group
  const regExp = /^.*(youtu.*be.*)\/(watch\?v=|embed\/|shorts|)(.*?((?=[&#?])|$)).*/
  let youtubeVideoId = regExp.exec(link)?.[3]

  if (youtubeVideoId === '') {
    youtubeVideoId = undefined
  }

  return youtubeVideoId
}

export function Video({ link, playing, onPauseOrEnded, className }: VideoProps) {
  const youtubeVideoId = extractYoutubeVideoId(link)

  return (
    <div className={cn(styles.container, className)}>
      <ReactPlayer
        url={`https://www.youtube.com/embed/${youtubeVideoId}`}
        config={{
          playerVars: {
            showinfo: 0,
            rel: 0,
          },
        }}
        playing={playing}
        controls
        stopOnUnmount
        onPause={onPauseOrEnded}
        onEnded={onPauseOrEnded}
        width="100%"
        height="100%"
      />
    </div>
  )
}
